import {Card, Col, Row} from "react-bootstrap";
import React from "react";
import MeasurementText from "../MeasurementText/MeasurementText";
import {getMonthLabel} from "../Utils/utils";

export default function TotalLeaksVolume(props) {
    const lastNDays = props.data.nLastDays;
    const totalLeakVolume = props.data.leaksVolume.current;
    const volumeUnit = props.volumeUnit;
    const lastMonthLabel = getMonthLabel(props.data.leaksVolume.lastMonthDate);
    const lastMonthValue = props.data.leaksVolume.lastMonthValue;
    const percentOfTotal = props.data.leaksVolume.increaseValue;
    const positivePercentOfTotal = percentOfTotal < 0 ? percentOfTotal * -1 : percentOfTotal;

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Card.Title className={'bold-title'}> Total Leaks Volume </Card.Title>
                <Card.Subtitle className={'text-muted'}> Last {lastNDays} Days </Card.Subtitle>
                <Card.Text style={{marginTop: '18px'}}>
                    <MeasurementText value={totalLeakVolume} unit={volumeUnit}/>
                </Card.Text>
                <hr/>
                <Card.Text>
                    <Row style={{marginTop: '18px'}}>
                        <Col md={5}>
                            <Card.Subtitle className={'text-muted'}> {lastMonthLabel} </Card.Subtitle>
                        </Col>
                        <Col md={7}>
                            <Card.Subtitle className={'text-muted'}> % Of Total Volume </Card.Subtitle>
                        </Col>
                    </Row>
                </Card.Text>
                <Card.Text>
                    <Row style={{marginTop: '4px'}}>
                        <Col md={5}>
                            <MeasurementText value={lastMonthValue} unit={volumeUnit}/>
                        </Col>
                        <Col md={7} className={'percentage-value'}>
                            <Card.Text style={{textAlign: 'center'}}>{positivePercentOfTotal || 0}%</Card.Text>
                        </Col>
                    </Row>
                </Card.Text>
            </Card.Body>
        </Card>
    )
}